import { useEffect, useState } from 'react';

// Keep the desktop view preference intact when switching between phone and desktop.
export default function useMobileEvaluation() {
  const [mobile,setMobile]=useState(()=>window.matchMedia('(max-width: 767px)').matches);
  useEffect(()=>{
    const query=window.matchMedia('(max-width: 767px)'),update=()=>setMobile(query.matches);
    update();query.addEventListener('change',update);
    return()=>query.removeEventListener('change',update);
  },[]);
  return mobile;
}
